import React from 'react';
import { Figure } from 'shared/ui/Figure';
import { formatMoney, formatPerTb } from 'shared/lib/format';

export type PriceCardProps = {
  label: string;          // "Solution Price" or "VDURA Pricing" for subscription-only vendors
  total: number;
  perRaw: number;
  perUseable: number;
  perEffective: number;
  loading?: boolean;
};

export function PriceCard({ label, total, perRaw, perUseable, perEffective, loading }: PriceCardProps) {
  return (
    <div className="rounded-[var(--radius-2)] border border-brand/30 bg-brand/5 p-3">
      <Figure label={label} value={formatMoney(total)} tone="brand" loading={loading} />
      <div className="mt-2 grid grid-cols-3 gap-2 border-t border-hairline/15 pt-2">
        <Figure label="$ / RAW" value={formatPerTb(perRaw)} loading={loading} />
        <Figure label="$ / Useable" value={formatPerTb(perUseable)} loading={loading} />
        <Figure label="$ / Effective" value={formatPerTb(perEffective)} loading={loading} />
      </div>
    </div>
  );
}
